import {API, Endpoints, ResponseType} from '@brg/api';
import {InitGiftRequest, UpdateGiftRequest} from "../constants/IGift";

const cardUrl = Endpoints.cardsMnePw;
const giftsUrl = Endpoints.gifts;

export default function giftUrlApi() {
    return {
        copyCalendarForGift(props: {calendarId: string}) {
            return API.fetch(`${cardUrl}/api/Calendar/CopyCalendarForGift`, {
                method: 'POST',
                body: JSON.stringify(props),
                response: ResponseType.Text,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
        },
        copyCardForGift(props: {userId: string, cardId: string, collectionId: string}) {
            return API.fetch(`${cardUrl}/api/Card/CopyCardForGift`, {
                method: 'POST',
                body: JSON.stringify(props),
                response: ResponseType.Text,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
        },
        getCard(cardId: string) {
            return API.fetch(`${cardUrl}/api/Card/GetCard?id=${cardId}`, {}).then((r) => r.json())
        },
        getCollectionsByUser(collectionId: string) {
            return API.request()
                .endpoint(cardUrl)
                .url('/api/Collection/GetCatalogs')
                .addQuery('userId', collectionId)
                .sendJson();
        },
        createGift(body: InitGiftRequest) {
            return API.request()
                .post()
                .endpoint(giftsUrl)
                .url('/api/Gifts/create')
                .body(body)
                .sendJson();
        },

        updateGift(body: UpdateGiftRequest) {
            return API.request()
                .post()
                .endpoint(giftsUrl)
                .url(`/api/Gifts/update`)
                .body(body)
                .sendJson();
        },

        setGiftAwaitingPayment(giftId: string) {
            return API.request()
                .post()
                .endpoint(giftsUrl)
                .url(`/api/Gifts/${giftId}/set-awaiting-payment`)
                .sendJson();
        },
    };
}
import {API, Endpoints, ResponseType} from '@brg/api';
import {InitGiftRequest, UpdateGiftRequest} from "../constants/IGift";

const cardUrl = Endpoints.cardsMnePw;
const giftsUrl = Endpoints.gifts;

export default function giftUrlApi() {
    return {
        copyCalendarForGift(props: {calendarId: string}) {
            return API.fetch(`${cardUrl}/api/Calendar/CopyCalendarForGift`, {
                method: 'POST',
                body: JSON.stringify(props),
                response: ResponseType.Text,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
        },
        copyCardForGift(props: {userId: string, cardId: string, collectionId: string}) {
            return API.fetch(`${cardUrl}/api/Card/CopyCardForGift`, {
                method: 'POST',
                body: JSON.stringify(props),
                response: ResponseType.Text,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
        },
        getCard(cardId: string) {
            return API.fetch(`${cardUrl}/api/Card/GetCard?id=${cardId}`, {}).then((r) => r.json())
        },
        getCollectionsByUser(collectionId: string) {
            return API.request()
                .endpoint(cardUrl)
                .url('/api/Collection/GetCatalogs')
                .addQuery('userId', collectionId)
                .sendJson();
        },
        createGift(body: InitGiftRequest) {
            return API.request()
                .post()
                .endpoint(giftsUrl)
                .url('/api/Gifts/create')
                .body(body)
                .sendJson();
        },

        updateGift(body: UpdateGiftRequest) {
            return API.request()
                .post()
                .endpoint(giftsUrl)
                .url(`/api/Gifts/update`)
                .body(body)
                .sendJson();
        },

        setGiftAwaitingPayment(giftId: string) {
            return API.request()
                .post()
                .endpoint(giftsUrl)
                .url(`/api/Gifts/${giftId}/set-awaiting-payment`)
                .sendJson();
        },
    };
}
